// extracted by mini-css-extract-plugin
export default {"row":"ProductsDashboard_row__SaewJ","col":"ProductsDashboard_col__fkUJA","card":"ProductsDashboard_card__ien8d"};